import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as appConstants from '../../../constants/appConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class HotSpotBtn extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            parentScreen: this.props.parentScreen,
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            activeScreenId: this.props.activeScreenId,
            enabledScreens: this.props.enabledScreens,
            completeScreens: this.props.completeScreens,
            className: "",
            locale: appHelper.getLocalData(this.props.screen),
            update: false,
            open_label: appHelper.getLocaleString("open_label"),
            hotspotVisibility: this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS ? "hidden" : "open",
            icon: {}
        };
        this.getClass = this.getClass.bind(this);
        this.setLocation = this.setLocation.bind(this);
        this.onClicked = this.onClicked.bind(this);
        this.screenIsEnabled = this.screenIsEnabled.bind(this);
        this.screenIsComplete = this.screenIsComplete.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.hasToolTip = this.hasToolTip.bind(this);
        this.onCloseToolTip = this.onCloseToolTip.bind(this);
        this.onCloseToolTipKeyboardAccessibility = this.onCloseToolTipKeyboardAccessibility.bind(this);
        this.onMouseIn = this.onMouseIn.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.getHotSpotButtonType = this.getHotSpotButtonType.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setButtonColour = this.setButtonColour.bind(this);
    }

    componentDidMount() {
        this.getAssets();
        this.setLocation();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
            this.setState({
                update: true
            });
        }

        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({},nextProps.userData)
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                open_label: appHelper.getLocaleString("open_label")
            });
        }
    }

    componentDidUpdate() {

    }

    screenIsEnabled() {
        return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
    }

    screenIsComplete() {
        return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
    }

    getStatus(){

        let screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_NOT_STARTED || screenUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
            return "not-started";
        } else if (screenUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }

    getClass() {
        let screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
        let className = "";

        if (this.state.screen.screen_id === this.props.activeScreenId) {
            className += "active ";
        }
        if (this.screenIsEnabled() === -1 && screenUserData.status !== objectConstants.STATUS_COMPLETE) {
            className += "disabled ";
        }

        return className;
    }

    onClicked(event) {
        if(appHelper.isDefined(event)){
            event.stopPropagation();
        }

        let screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
        if (this.screenIsEnabled() > -1 || screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.props.onClickFunc(this.state.screen);
        }
    }

    setLocation() {
        let hotSpotRef = this.refs[`hotSpot_${this.state.screen_id}`];
        TweenLite.set(hotSpotRef, {
            left: this.state.screen.hotspot_x_coordinate,
            top: this.state.screen.hotspot_y_coordinate,
        });
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onClicked();
        }
    }

    isDisabled(){
        let screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
        return this.screenIsEnabled() > -1 || screenUserData.status !== objectConstants.STATUS_COMPLETE;
    }


    hasToolTip() {
        if (this.screenIsEnabled() > -1 && (this.props.parentScreen.hotspot_button_type === objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER || this.props.parentScreen.hotspot_button_type === objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON)){
            return true;
        }
    }

    onCloseToolTip(event){
        event.stopPropagation();
        this.setState({hotspotVisibility: "hidden"});
    }

    onCloseToolTipKeyboardAccessibility(){
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.stopPropagation();
            this.setState({hotspotVisibility: "hidden"});
        }
    }

    getHotSpotButtonType(){
        let screen = this.props.parentScreen;
        let returnVal = "";
        switch (screen.hotspot_button_type) {
            case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER:
                returnVal = "hot-spot-hide";
                break;
            case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_LABEL:
                returnVal = "hot-spot";
                break;
            case objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON:
                returnVal = "hot-spot-sml-icon-only";
                break;
            case objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON_LABEL:
                returnVal = "hot-spot-sml-icon";
                break;
            case objectConstants.HOT_SPOT_BUTTON_TYPE_LARGE_ICON:
                returnVal = "hot-spot-lg-icon-only";
                break;
            case objectConstants.HOT_SPOT_BUTTON_TYPE_LARGE_ICON_LABEL:
                returnVal = "hot-spot-lg-icon";
                break;
        }
        return returnVal;
    }

    getAssets() {
        let icon = {};

        if (appHelper.isDefined(this.state.screen.assets.icon)) {
            icon = appHelper.getIconAsset(this.state.screen.assets.icon);
        }

        this.setState({
            icon: Object.assign({}, icon)
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setButtonColour(){
        if(this.props.parentScreen.hotspot_colour !== objectConstants.INHERIT && this.props.parentScreen.hotspot_label_colour !== objectConstants.INHERIT) {
            return {
                background: this.props.parentScreen.hotspot_colour,
                color: this.props.parentScreen.hotspot_label_colour
            };
        }else if(this.props.parentScreen.hotspot_colour !== objectConstants.INHERIT && this.props.parentScreen.hotspot_label_colour === objectConstants.INHERIT) {
            return {
                background: this.props.parentScreen.hotspot_colour

            };
        } else if(this.props.parentScreen.hotspot_colour === objectConstants.INHERIT && this.props.parentScreen.hotspot_label_colour !== objectConstants.INHERIT) {
            return {
                color: this.props.parentScreen.hotspot_label_colour
            };
        }else{
            return {};
        }

    }

    onMouseIn(){
        if(this.state.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS){
            this.setState({hotspotVisibility: "open"});
        }
    }

    onMouseOut(){
        if(this.state.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) {
            this.setState({hotspotVisibility: "hidden"});
        }
    }

    render() {
        return (
            <div className={`${this.getHotSpotButtonType()} ${this.state.className} hot-spot-${this.state.screen.hotspot_label_type} ${this.getStatus()} ${this.getClass()}`}
                 onClick={this.onClicked}
                 onKeyDown={this.setKeyboardAccessibility}
                 onMouseEnter={this.onMouseIn}
                 onMouseLeave={this.onMouseOut}
                 ref={`hotSpot_${this.state.screen_id}`}
                 id={`hotSpot_${this.state.screen.screen_id}`}
                 role="link"
                 tabIndex="0"
                 aria-current={this.state.screen.screen_id === this.props.activeScreenId}
                 aria-disabled={this.isDisabled()}
                 style={
                     this.setButtonColour()
                 }
            >

                {
                    appHelper.isDefined(this.state.icon.src)
                    ?
                    <div className="hot-spot-icon">
                        <img src={this.getImagePath(this.state.icon.src)} alt=""/>
                    </div>
                    :
                    null
                }

                <div className="hot-spot-label" dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                {
                    this.hasToolTip()
                    ?
                        <div className={`hot-spot-tool-tip ${this.state.hotspotVisibility}`} onClick={this.onCloseToolTip}  onKeyDown={this.onCloseToolTipKeyboardAccessibility} role="link" tabIndex="0">
                            <div className="close-btn"/>
                            <h5 dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                            <button className={`btn guroo-btn`} onClick={this.onClicked} style={this.setButtonColour()}>{this.state.open_label}</button>
                        </div>
                    :
                        null
                }
                {
                    this.hasToolTip() && this.state.hotspotVisibility === "open"
                        ?
                        <div className="hot-spot-hover-area"/>

                        :
                        null
                }
            </div>
        );

    }
}

HotSpotBtn.propTypes = {
    parentScreen: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
    activeScreenId: PropTypes.number,
    enabledScreens: PropTypes.array.isRequired,
    completeScreens: PropTypes.array.isRequired,
    onClickFunc: PropTypes.func,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

HotSpotBtn.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HotSpotBtn);



/** WEBPACK FOOTER **
 ** ./src/components/screens/hotspotScreen/HotSpotBtn.js
 **/